var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.683 14.545l2.13.426a1.681 1.681 0 002.937.306h9.605a1.682 1.682 0 002.768 0h.799c.035 0 .07-.008.102-.024l1.455-.728a.228.228 0 00.126-.204v-1.455a.227.227 0 00-.067-.161l-.728-.728a.23.23 0 00-.123-.064l-4.333-.722-4.336-2.168A.23.23 0 0012.917 9H9.278a.228.228 0 00-.09.018l-5.051 2.165h-1.41a.227.227 0 00-.227.228v2.91c0 .11.077.203.183.224zm3.684 1.005a1.23 1.23 0 01-1.229-1.228 1.23 1.23 0 011.229-1.228 1.23 1.23 0 011.228 1.228 1.23 1.23 0 01-1.228 1.228zm12.372 0a1.23 1.23 0 01-1.228-1.228 1.23 1.23 0 011.228-1.228 1.23 1.23 0 011.229 1.228 1.23 1.23 0 01-1.229 1.228zm-7.05-6.095h1.174l3.457 1.728h-4.632V9.455zm-3.634.544l1.27-.544h1.909v1.728H7.462L8.055 10zm-.648.277l-.453.907H5.291l2.116-.907z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgCoupe;